<a class="insured-list-entry-container"
   [class.active-entry]="selected()"
   [routerLink]="['/insured', item().uuid]"
   [title]="item().name"
   (click)="onEntryClick()"
>
  <span class="insured-data-completeness-display"
        [ngClass]="item().complete ? 'bg-lime-500' : 'bg-amber-500'"
  ></span>

  <div class="insured-link">
    <span class="truncate">{{ item().name }}</span>
  </div>

  @if (item().updated) {
    <span class="sync-indicator">
      <i class="pi pi-sync"></i>
    </span>
  }
</a>
